import actionTypes from '../constants/action-types';

const setIntegration = (type) => ({
  type: actionTypes.SET_INTEGRATION,
  payload: {
    type,
  },
});

export default setIntegration;
